import { useSearchParams } from "react-router-dom";
import { Subtree } from "subtree.js/react";
import { pick } from "trunk.js";
import type { AppDeps } from "../../app-deps";
import { CustomerCartsController } from "./customer-carts-controller";
import { CustomerCartsPage } from "./customer-carts-page";

/** The customer served rides in the URL, for the tabs' links. */
export function CustomerCartsRoute({ deps }: { deps: AppDeps }) {
  const [params] = useSearchParams();
  const customerId = params.get("customer");
  return (
    <Subtree
      key="customer-carts"
      deps={[customerId]}
      controller={() =>
        new CustomerCartsController(
          pick(
            deps,
            "client",
            "authHandler",
            "storeRepository",
            "providersRepository",
            "pendingCartsRepository",
            "stripeTerminal",
          ),
          customerId,
        )
      }
    >
      <CustomerCartsPage />
    </Subtree>
  );
}
